import { defineComponent as _defineComponent } from 'vue'
import {
  useI18n,
} from "@/composables/useI18n";

import {
  computed,
  onMounted,
  ref,
  unref,
  watch,
} from "vue";

import {
  AccountingPartner,
  DEFAULT_SORT_COLUMN_FETCH_ACCOUNTINGPARTNERS,
  FetchAccountingPartnersParam,
} from "@/components/customers/scripts";

import {
  getAccessRights,
} from "@/authorization";

import {
  accountDataPolicies,
} from "@/authorization/policies";

import FloatingActionButton from "@/components/buttons/FloatingActionButton.vue";

import {
  cardExist,
} from "@/components/cards/scripts";

import {
  debounce,
} from "@/scripts/Common/HelperFunctions";

import {
  fetchAccountingPartners,
} from "@/components/customers/scripts";

import {
  resetPassword,
} from "@/components/administrations/scripts/passwordReset";

import {
  logError,
} from "@/scripts/Common";

import InfoSnackbar from "@/components/children/InfoSnackbar.vue";

import {
  useSnackbar,
} from "@/composables/useSnackbar";

import {
  isAccountingPartner
} from "../customers/scripts/typeGuards";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordReset',
  emits: [
  'onFetchError'
],
  setup(__props, { emit: emits }) {


const {
  t,
} = useI18n();

const {
  hasEditRights,
} = getAccessRights(accountDataPolicies);



const accountingPartnerComboSelection = ref<AccountingPartner | undefined>(undefined);
const accountingPartnerSearchInput = ref<string | undefined>(undefined);
let ignoreAccountingPartnerSearchInputChange = false; // when the accountingPartner is selected from the combobox, the accountingPartner change that follows should not trigger a reload of the accountingPartner list

const tabs = ref(null);
const vendorForm = ref();

const isValidationBusy = ref(false);

const vendorValid = ref(false);
const userValid = ref(false);

const selectedAccountingPartnerId = ref(0);
const accountingPartners = ref<AccountingPartner[]>([]);

const cardNumber = ref<number>();
const cardErrorMessage = ref<string | string[]>("");

const snackbarRef = ref(null);
const {
  snackbarStatus,
  snackbarText,
  showSnackbar
} = useSnackbar(snackbarRef);

const onHandleFetchError = ({error}: {
  error: any
}) => {
  emits('onFetchError', {error})
}

const canResetUser = computed(() => hasEditRights
  && unref(cardNumber) && !unref(isValidationBusy)
  && unref(userValid));

const canResetVendor = computed(() => hasEditRights
  && unref(selectedAccountingPartnerId)
  && unref(vendorValid));

const onHandleResetPassword = async (group: 'customer' | 'user', id: number | undefined) => {
  if (!id) {
    logError("Id is undefined or zero");
    return;
  }

  const {error} = await resetPassword(group, id);

  if (error) {
    onHandleFetchError({error});
    return;
  }

  showSnackbar({ status: 'success', statusText: [t('success_message')] })
}

const loadAccountingPartners = async () => {

  const fetchArgs: FetchAccountingPartnersParam = {
    sortColumn: DEFAULT_SORT_COLUMN_FETCH_ACCOUNTINGPARTNERS
  };

  if(accountingPartnerSearchInput.value) fetchArgs.company = accountingPartnerSearchInput.value;

  const {response, error} = await fetchAccountingPartners(fetchArgs);

  if (error) {
    onHandleFetchError({error});
    return;
  }

  accountingPartners.value = response ?? [];
}

watch(cardNumber, debounce(() => {
  if(!cardNumber.value){
    cardErrorMessage.value = [];
    return;
  }

  isValidationBusy.value = true;
  cardExist(unref(cardNumber)).then(result => {
    cardErrorMessage.value = result ? "" : t('rule_user_not_exist');
    userValid.value = result;
  }).catch(() => {
    userValid.value = false;
    cardErrorMessage.value = t('rule_could_not_check');
  }).finally(() => {
    isValidationBusy.value = false;
  });
}))

const validate = () => {
  vendorForm.value?.validate();
}

const onHandleAccountingPartnerSelectionChange = () => {
  const accountingPartnerId = accountingPartnerComboSelection.value?.id; //  accountingPartnerComboSelection.value could be something else than an AccountingPartner (string company without results)
  validate();

  if (!accountingPartnerId || !isAccountingPartner(accountingPartnerComboSelection.value)) {
    selectedAccountingPartnerId.value = 0;
    return;
  }
  ignoreAccountingPartnerSearchInputChange = true; // avoid a reload of the accountingPartner list when the partner is selected from the combobox

  selectedAccountingPartnerId.value = accountingPartnerId;
}

watch(() => accountingPartnerSearchInput.value, debounce(async () => {
  if(ignoreAccountingPartnerSearchInputChange) {
    ignoreAccountingPartnerSearchInputChange = false;
    return;
  }
  await loadAccountingPartners();
}));

onMounted(() => validate())


return { __sfc: true,t, hasEditRights, emits, accountingPartnerComboSelection, accountingPartnerSearchInput, ignoreAccountingPartnerSearchInputChange, tabs, vendorForm, isValidationBusy, vendorValid, userValid, selectedAccountingPartnerId, accountingPartners, cardNumber, cardErrorMessage, snackbarRef, snackbarStatus, snackbarText, showSnackbar, onHandleFetchError, canResetUser, canResetVendor, onHandleResetPassword, loadAccountingPartners, validate, onHandleAccountingPartnerSelectionChange, FloatingActionButton, InfoSnackbar }
}

})